import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";
$ = jQuery;

$(() => {
  Fancybox.bind("[data-fancybox]", {
    // Your options go here
  });
  $(".oss__item").on("mouseenter", function () {
    $(this).find(".oss__hidden").show("slow");
  });
  $(".oss__item").on("mouseleave", function () {
    $(this).find(".oss__hidden").hide("slow");
  });
  console.log("passe");
  $(".site-header__burger").on("click", function() {
    $("html").toggleClass("is-menu-open lock-scroll");
  });
/*
  $(".logos__content").slick({
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nav: false,
    dots: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 7,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
*/
  // $(".oss__content").slick({
  //   mobileFirst: true,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   nav: false,
  //   dots: false,
  //   responsive: [
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 2,
  //       },
  //     },
  //     {
  //       breakpoint: 1200,
  //       settings: {
  //         slidesToShow: 4,
  //         slidesToScroll: 2,
  //       },
  //     },
  //     {
  //       breakpoint: 1800,
  //       settings: {
  //         slidesToShow: 6,
  //         slidesToScroll: 6,
  //       },
  //     },
  //     // You can unslick at a given breakpoint now by adding:
  //     // settings: "unslick"
  //     // instead of a settings object
  //   ],
  // });
});
